import { useCallback, memo } from 'react';
import { useNavigate } from 'react-router';
import { BettyIgoLogo } from '@betty/moonlight';

function LinkedBettyIgoLogo() {
  const navigate = useNavigate();

  const onBettyPress = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const onIgoPress = useCallback(() => {
    window.open('https://igamingontario.ca/en', '_blank');
  }, []);

  return <BettyIgoLogo onBettyPress={onBettyPress} onIgoPress={onIgoPress} />;
}

export default memo(LinkedBettyIgoLogo);
